import { http } from "helpers/Http";
import { IPlace } from "types/Place";
import logger from "../../../../components/Logger";

const path = 'src/services/api/requests/Place/index.ts'

export async function fetchAPIPlace(id: number): Promise<IPlace> {
    const url = `places/${id}`;
    const data = http.get(url).then((response) => response.data);

    logger.log("************************************************************************************")
    logger.log(`| FILE: ${path} | METHOD: postUpdateUserOrderStatus`)
    logger.log("| url: ", url)
    logger.log("| id: ", id)
    logger.log("| promise returned ", data)
    logger.log("************************************************************************************")


    return data;
}